<div class="d-lg-block d-none">
  <fgb-banner [title]="'faq.page.title' | translate"></fgb-banner>
</div>

<div class="d-lg-none">
  <fgb-mobile-page-header
    pageTitle="faq.page.title"
    [showFooter]="true"
    [showQr]="false"
    [showBalance]="false"
    [backButtonLink]="'/'"
  ></fgb-mobile-page-header>
</div>

<div class="container" [ngClass]="isCorporate ? 'corporate-colors' : 'default-color'">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
